<template>
	<div>
		<select
			v-model="model"
			:class="'form-control '.concat(classes)"
			@change="hndSelect(model)"
			:name="this.name"
			:disabled="isDisabled()"
			:style="this.inputStyles">
			<option :value="null">Select option</option>
			<option
				:key="opt.Id"
				v-for="opt in options"
				:value="valueProp ? opt[valueProp] : (stringifiedValue ? JSON.stringify(opt) : opt)"
				:style="{display: opt.hidden ? 'none' : 'initial'}">{{ displayText(opt) }}</option>
		</select>
		<div v-if="container && containerValues.length" class="dyn-inp-container">
			<label class="" :key="inp.Id" v-for="(inp, idx) in containerValues">
				{{ displayText(inp) }} <span class="fa fa-close" @click="removeFromContainer(inp)" style="cursor:pointer"></span>
				<input type="hidden" :name="containerInputName.replaceAll('[]', `[${idx}]`)" :value="inp[valueProp]">
			</label>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		url: {
			type: String,
			required: false	// false if passing store or providedOptions
		},
		url2: {
			type: String,
			required: false
		},
		dataPath: {
			type: String,
			required: false	// false if passing store or providedOptions
		},
		store: {
			type: String,	// if not passing url & dataPath
			required: false,
			default: ''
		},
		storePath: {
			type: String,	// if passing store
			required: false,
			default: ''
		},
		displayProp: {
			type: String,
			required: false,
			default: ''
		},
		displayPhrase: {
			type: [String, Function],
			required: false,
			default: ''
		},
		valueProp: {
			type: String,
			required: false,
			default: null
		},
		container: {
			type: Boolean,
			required: false,
			default: false
		},
		containerValues: {
			type: Array,
			required: false,
			default: () => {
				return []
			}
		},
		containerInputName: {
			type: String,
			required: false,
			default: ''
		},
		excludeSelected: {
			type: Boolean,
			required: false,
			default: false
		},
		clearOnSelect: {
			type: Boolean,
			required: false,
			default: false
		},
		classes: {
			type: String,
			required: false,
			default: ''
		},
		name: {
			type: String,
			required: false,
			default: ''
		},
		value: {
			type: [String, Object],
			required: false,
			default: ''
		},
		inputStyles: {
			type: Object,
			required: false,
			default: () => { return {} }
		},
		disabled: {
			type: Boolean,
			required: false,
			default: () => { return false }
		},
		cleanApi: {
			type: Boolean,
			required: false,
			default: false
		},
		stringifiedValue: {
			// if no valueProp is provided, value can be stringified object
			type: Boolean,
			required: false,
			default: false
		},
		providedOptions: {
			type: [Array, null],
			required: false,
			default: null
		}
	},
	data () {
		return {
			model: null,
			options: []
		}
	},
	computed: {
		storeItems () {
			let obj = []
			if (this.store) {
				obj = JSON.parse(JSON.stringify(this.$store.state[this.store]))
				if (this.storePath.indexOf('.') > -1) {
					this.storePath.split('.').forEach(part => {
						obj = obj[part]
					})
				} else if (this.storePath) {
					obj = obj[this.storePath]
				}
			}
			return obj
		}
	},
	methods: {
		isDisabled () {
			return this.disabled
		},
		getOptions () {
			let dispatchAction = 'callApi'
			if (this.cleanApi) {
				dispatchAction = 'cleanApi'
			}
			return this.$store.dispatch(dispatchAction, {
				method: 'GET',
				url: this.url
			}).then(res => {
				let obj = res
				this.dataPath.split('.').forEach(key => {
					obj = obj[key]
				})
				this.preSelectOption(this.$props.value, obj)
				this.$set(this, 'options', obj)
				this.$emit('gotOptions', obj)
			})
		},
		preSelectOption (value, options) {
			if (!options) {
				return true
			}
			const selectedItem = options.find(opt => {
				if (this.valueProp) {
					return opt[this.valueProp] === value
				} else {
					return this.stringifiedValue ? JSON.stringify(opt) === value : opt === value
				}
			})
			if (!selectedItem) {
				return false
			}
			if (this.valueProp) {
				this.model = selectedItem[this.valueProp]
			} else {
				this.model = this.stringifiedValue ? JSON.stringify(selectedItem) : selectedItem
			}
		},
		hndSelect (item) {
			this.$emit('change', item)
			if (!item) {
				return null
			}
			if (this.container) {
				let actualItem = item
				if (this.valueProp) {
					actualItem = this.options.find(o => o[this.valueProp] === item)
				}
				this.$emit('addItem', actualItem)
				this.$nextTick(() => {
					this.model = null
					this.options = JSON.parse(JSON.stringify(this.storeItems)).filter(item => !this.containerValues.find(i => i.Id === item.Id))
				})
			}
			if (this.clearOnSelect) {
				this.model = ''
			}
		},
		removeFromContainer (item) {
			this.$emit('remItem', item)
			this.$nextTick(() => {
				this.options = JSON.parse(JSON.stringify(this.storeItems)).filter(item => !this.containerValues.find(i => i.Id === item.Id))
			})
		},
		displayText (item) {
			let str = ''
			if (this.displayProp) {
				str = item[this.displayProp]
			} else if (this.displayPhrase) {
				if (typeof this.displayPhrase === 'string') {
					// check for {{property}} inside the given phrase string
					const propsArr = this.displayPhrase.match(new RegExp(/{{.*?}}/g))
					item.displayPhrase = item.displayPhrase || this.displayPhrase
					for (let i = 0; i < propsArr.length; i++) {
						item.displayPhrase = item.displayPhrase.replaceAll(propsArr[i], item[propsArr[i].slice(2, -2)])
					}
					str = item.displayPhrase
				} else if (typeof this.displayPhrase === 'function') {
					str = this.displayPhrase(item)
				}
			}
			return str
		}
	},
	async beforeMount () {
		if (this.url) {
			await this.getOptions()
		} else if (this.providedOptions) {
			// wait for 'providedOptions' watch to fill in the options
		} else {
			// this.options = JSON.parse(JSON.stringify(this.storeItems)).filter(item => !this.containerValues.find(i => i.Id === item.Id))
			// this.preSelectOption(this.$props.value, this.options)
			// setTimeout(() => {
			// 	// timeout fix for first time shown options
			// 	this.options = JSON.parse(JSON.stringify(this.storeItems)).filter(item => !this.containerValues.find(i => i.Id === item.Id))
			// }, 800)
			// wait for 'storeItems' watch
		}
	},
	watch: {
		'$props.value': {
			handler: function (n) {
				this.preSelectOption(n, this.options)
			},
			immediate: true
		},
		'providedOptions': {
			handler: function (n) {
				this.options = n
			},
			immediate: true
		},
		'storeItems': {
			handler: function (n) {
				if (n) {
					this.options = JSON.parse(JSON.stringify(n)).filter(item => !this.containerValues.find(i => i.Id === item.Id))
					this.preSelectOption(this.$props.value, this.options)
				}
			},
			immediate: true
		}
	}
}
</script>
<style lang="scss" scoped>
.dyn-inp-container {
	border:1px dashed;
	padding:0.5em 15px;
	margin-top:10px;
	border: 1px dashed #9f9f9f;
	padding: 6px 6px 2px 7px;
	margin-top: 10px;
	margin-bottom: 15px;

	label {
		font-size:14px;
		border:1px solid #aaa;
		border-radius:3px;
		background-color:#eee;
		padding:0.25em 0.5em;
		&:nth-child(n+1) {
			margin-right:5px;
		}
		.fa-close { color:red; }
	}
}
.font-weight-bold {
	font-weight:600;
}
</style>
